import { Action, createReducer, on } from '@ngrx/store';
import { MissedRecallAction } from './missed-recall-action.service';

export const STORE_FEATURE_KEY_MISSED_RECALL = 'missedAndRecallReport';

export interface EscalatingReportState {
    loading: boolean;
    // TODO: Move down one level to "reports" or even a missedReports and a recallsReports
    jobId: number; // Currently not used - only useful to invalidate state if new jobId is used
    fromDate: Date;
    inProgress: Array<any>;
    successful: Array<any>;
    unsuccessful: Array<any>;
}

const getDaysBeforeDate = (daysBefore, date: Date): Date => {
    date.setDate(date.getDate() - daysBefore);

    return date;
};

const initialEscalatingReportState: EscalatingReportState = {
    loading: false,

    jobId: 0,
    fromDate: getDaysBeforeDate(30, new Date()),

    inProgress: [],
    successful: [],
    unsuccessful: []
};

// NgRX 8 syntax
const reducer = createReducer(
    initialEscalatingReportState,

    on(MissedRecallAction.setFromDate, (state, date) => ({
        ...state,

        fromDate: (date as any).fromDate
    })),

    on(MissedRecallAction.getEscalateReportSuccess, (state, reports) => ({
        ...state,

        loading: false,

        inProgress: (reports as any).inProgress as Array<any>,
        successful: (reports as any).successful as Array<any>,
        unsuccessful: (reports as any).unsuccessful as Array<any>
    })),

    on(MissedRecallAction.getEscalateReport, (state, searchParameters) => ({
        ...state,
        loading: true,
        inProgress: [],
        successful: [],
        unsuccessful: []
    }))
);

// tslint:disable-next-line:only-arrow-functions (AOT required named function - not arrow notation)
export function missedRecallReportStateReducer(state: EscalatingReportState | undefined, action: Action): EscalatingReportState {
    return reducer(state, action);
}
